module.exports = __webpack_public_path__ + "img/woman-organized.3cd7b089.png";